import { makeStyles, colors } from "@material-ui/core";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.background.default,
      transition: "all .5s ease-out",

      margin: 0,
      width: "100%",
      height: "100% !important",
      overflowX: "hidden",
      overflowY: "auto",
    },

    wrapper: {},

    subHeader: {
      margin: 0,
      padding: "50px 0 20px 0",

      "& .mainTitle": {
        fontSize: 26,
        fontWeight: theme.typography.fontWeightMedium,
      },

      "& .subTitle": {
        fontSize: 16,
      },

      "& .subHeaderLeft": {
        [theme.breakpoints.down("xs")]: {
          textAlign: "center",
        },
      },
    },

    actionWrapper: {
      paddingTop: 6,

      [theme.breakpoints.down("xs")]: {
        textAlign: "center",
        padding: "40px 30px 0 30px",
      },
    },

    action: {
      marginLeft: 20,
      paddingTop: 10,

      "& button": {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },

    tabsWrapper: {
      height: 50,
      borderBottom: `1px solid ${defaultBorder(theme)}`,
    },

    tabs: {
      position: "relative",
      backgroundColor: theme.palette.common.white,
      width: "100%",
      height: "100%",

      listStyleType: "none",
      margin: 0,
      padding: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",

      [theme.breakpoints.down("xs")]: {
        padding: "0 30px",
        overflowX: "auto",
        overflowY: "hidden",
      },
    },

    tabItem: {
      height: "100%",
      listStyle: "none",

      [theme.breakpoints.down("xs")]: {
        float: "none",
      },

      "& a": {
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "nowrap",

        marginRight: theme.spacing(4),
        textDecoration: "none",
        color: colors.grey[600],
        fontSize: 14,
        borderBottom: `2px solid transparent`,

        "&.active": {
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightMedium,
          borderBottom: `2px solid ${theme.palette.text.primary}`,
        },

        "& .icon": {
          display: "inline-block",
          marginRight: 10,
          fontSize: 16,
        },

        "& :hover": {
          textDecoration: "none",
        },
      },
    },

    tabContent: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(4),

      [theme.breakpoints.down("xs")]: {
        padding: "40px 30px 40px 30px",
      },
    },

    slideWrapper: {
      animation: `$slideIn 300ms ${theme.transitions.easing.easeInOut}`,
    },

    "@keyframes slideIn": {
      "0%": {
        opacity: 0,
        transform: "translateX(10%)",
      },
      "100%": {
        opacity: 1,
        transform: "translateX(0)",
      },
    },
  }),
  {
    name: "dashboard-style",
    flip: null,
  }
);
